export const RESET = 'EXSBITEM_UPDATE_RESET'
export const SET_ERROR = 'EXSBITEM_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXSBITEM_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXSBITEM_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXSBITEM_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXSBITEM_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXSBITEM_UPDATE_UPDATE_RETRIEVED'
